/*
 * @Descripttion: 
 * @version: 
 * @Author: congsir
 * @Date: 2023-03-08 14:21:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-10 15:19:06
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'windi.css'
createApp(App).use(store).use(router).mount('#app')
